import PasteOptionViewState from '../store/schema/PasteOptionViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setPasteOptionSelectedIndex')(function setPasteOptionSelectedIndex(
    viewState: PasteOptionViewState,
    index: number
) {
    viewState.subMenuSelectionIndex = index;
});
